"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSize = exports.lowerFirst = exports.snakeToCamelCase = exports.camelToSnakeCase = exports.strToSnakeCase = exports.isUUID = exports.isEmail = exports.formatPhone = exports.parseEnvVar = exports.removeWhitespace = exports.capitalize = exports.parseName = exports.contains = exports.readableFileSize = exports.padding = void 0;
exports.padding = (m, width, z = "0") => {
    const n = String(m);
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};
exports.readableFileSize = (size) => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (Number((size / Math.pow(1024, i)).toFixed(2)) +
        " " +
        ["B", "KB", "MB", "GB", "TB"][i]);
};
exports.contains = (a, b) => {
    return a.toLowerCase().indexOf(b.toLowerCase()) > -1;
};
exports.parseName = (name) => {
    return { i: name.substr(1, 1), key: name.substr(4, name.length - 1) };
};
exports.capitalize = (s) => {
    var h = s.charAt(0).toUpperCase();
    var t = s.slice(1).toLowerCase();
    return h + t;
};
exports.removeWhitespace = (value) => {
    return value.replace(/\s/g, "");
};
exports.parseEnvVar = (value = "") => {
    const end = value.length - 1;
    const isDoubleQuoted = value[0] === '"' && value[end] === '"';
    const isSingleQuoted = value[0] === "'" && value[end] === "'";
    if (isSingleQuoted || isDoubleQuoted) {
        value = value.substring(1, end);
        if (isDoubleQuoted) {
            const RE_NEWLINES = /\\n/g;
            const NEWLINE = "\n";
            value = value.replace(RE_NEWLINES, NEWLINE);
        }
    }
    else {
        value = value.trim();
    }
    return value;
};
exports.formatPhone = (p) => {
    const usPrefix = p.substring(0, 3);
    const intlPrefix = p.substring(0, 2);
    if (usPrefix === "001" && p.length === 13) {
        return ("+1 (" + p.substr(3, 3) + ") " + p.substr(6, 3) + "-" + p.substr(9, 4));
    }
    if (intlPrefix === "00" && p.length === 13) {
        return ("+" +
            p.substr(2, 2) +
            " " +
            p.substr(4, 2) +
            " " +
            p.substr(6, 3) +
            " " +
            p.substr(9, 2) +
            " " +
            p.substr(11, 2));
    }
    if (intlPrefix === "00" && p.length === 14) {
        return "+" + p.substr(2, 2) + " " + p.substr(4, 4) + " " + p.substr(8, 6);
    }
    if (intlPrefix != "00" && p.length === 10) {
        return (p.substr(0, 3) +
            " " +
            p.substr(3, 3) +
            " " +
            p.substr(6, 2) +
            " " +
            p.substr(8, 2));
    }
    if (intlPrefix != "00" && p.length === 11) {
        return (p.substr(0, 4) +
            " " +
            p.substr(4, 3) +
            " " +
            p.substr(5, 2) +
            " " +
            p.substr(9, 2));
    }
    return p;
};
exports.isEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9\.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i;
    const regexResult = email.match(emailRegex);
    if (!regexResult) {
        return false;
    }
    return regexResult.includes(email);
};
exports.isUUID = (str, version = "all") => {
    const patterns = {
        3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
        4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
        5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
        all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    };
    const pattern = patterns[version];
    return pattern && pattern.test(str);
};
exports.strToSnakeCase = (str) => str
    .trim()
    .replace(/[^A-Za-z0-9]+/g, "_")
    .toLowerCase();
exports.camelToSnakeCase = (str) => str.replace(/([a-z1-9])\.?(?=[A-Z]+)/g, "$1_").toLowerCase();
exports.snakeToCamelCase = (str) => str.replace(/(\_\w)/g, (c) => c[1].toUpperCase());
exports.lowerFirst = (s) => typeof s === "string" ? s.charAt(0).toLowerCase() + s.substr(1) : s;
exports.formatSize = (s) => {
    const kb = s / 1000;
    if (kb > 999) {
        return Math.round(kb / 100) / 10 + "MB";
    }
    return Math.round(kb) + "KB";
};
